import { Typography, Space, Button } from 'antd'

import { RefundTableCell } from '../table.common'

const { Text } = Typography

export const CellRefundAction: RefundTableCell = (
	_,
	{ refundDate, status, onClickApprove, onClickReject },
) => {
	if (status === 'approve') {
		return (
			<Text strong style={{ color: '#1677ff' }}>
				환급 승인
			</Text>
		)
	}

	if (status === 'declined') {
		return (
			<Text strong type="danger">
				환급 거절
			</Text>
		)
	}

	return (
		<Space direction="vertical">
			<Button
				type="primary"
				// disabled={isBefore(Date.now(), refundDate)}
				onClick={() => {
					onClickApprove()
				}}
				size="small"
			>
				환급승인
			</Button>
			<Button
				// disabled={isBefore(Date.now(), refundDate)}
				onClick={() => {
					onClickReject()
				}}
				size="small"
			>
				환급거절
			</Button>
		</Space>
	)
}
